import React, { PureComponent } from 'react';

import classNames from 'classnames';
import get from 'lodash/get';
import intersection from 'lodash/intersection';
import isEqual from 'lodash/isEqual';
import { PropTypes } from 'prop-types';

import FormContext from './FormContext';
import { CONDITIONS_PROPS } from './Validation';

class FormControl extends PureComponent {
  static Context = FormContext;

  static propTypes = {
    children: PropTypes.object,
    context: PropTypes.object,
    changeListener: PropTypes.func
  };

  constructor(props) {
    super(props);
    const { children, context } = props;
    const { props: childrenProps } = children;

    context.setField(childrenProps);
  }

  componentDidUpdate(prevProps) {
    const { children, context, changeListener } = this.props;
    const { props } = children;

    const valueChanged = !isEqual(
      prevProps.children.props.value,
      children.props.value
    );

    changeListener && changeListener(valueChanged);

    if (
      valueChanged ||
      this.restrictionsChanged(prevProps.children.props, children.props)
    ) {
      context.setField(props);
    }
  }

  restrictionsChanged(prevProps, props) {
    const valuesRestrictionsProps = Object.values(CONDITIONS_PROPS);
    const keysProps = Object.keys(props);
    const intersectionRestrictions = intersection(
      valuesRestrictionsProps,
      keysProps
    );

    const changed = intersectionRestrictions.reduce((changed, propName) => {
      changed = changed || prevProps[propName] !== props[propName];
      return changed;
    }, false);

    return changed;
  }

  handleChange = (event) => {
    const setValue = get(this, 'props.context.setValue');
    const onChange = get(this, 'props.children.props.onChange');

    onChange && onChange(event);
    setValue && setValue(event);
  };

  render() {
    const { children, context } = this.props;
    const { props } = children;
    const { errors, inputs, submitted } = context.state;

    return React.cloneElement(children, {
      ...props,
      submitted,
      value: inputs[props.name],
      error: errors[props.name],
      onChange: this.handleChange,
      className: classNames('form__control', props.className)
    });
  }
}

export default (props) => (
  <FormContext.Consumer>
    {(context) => <FormControl {...props} context={context} />}
  </FormContext.Consumer>
);
